module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "stdreq-detail",
      "id": "stdreq-detail"
    }
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "700",
      "margin-bottom": "3px"
    }
  }, [_vm._v(_vm._s(_vm.labels['STD_REQP1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].numreqst))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "stdreq-detail-accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdreq-detail-accordion",
      "href": "#stdreq-detail-treqest1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STD_REQP1']['30']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "stdreq-detail-treqest1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].desc_codcomp))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].codemprq) + " - " + _vm._s(_vm.data['treqest1'].desc_codemprq))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data['treqest1'].dtereq)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].codempap) + " - " + _vm._s(_vm.data['treqest1'].desc_codempap))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data['treqest1'].dteaprov)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].codemprc) + " - " + _vm._s(_vm.data['treqest1'].desc_codemprc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].desc_codpos))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data['treqest1'].desc_stareq))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.data['treqest1'].totreq
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP1']['140']) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.data['treqest1'].totqtyact
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP1']['160']) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.data['treqest1'].toava
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP1']['180']) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['110']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.data['treqest1'].desnote
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdreq-detail-accordion",
      "href": "#stdreq-detail-treqest2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STD_REQP2']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdreq-detail-treqest2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP1']['20']))]), _vm._v(" "), _c('hrms-dropdown', {
    attrs: {
      "options": _vm.codposDropdown,
      "showNone": false
    },
    model: {
      value: (_vm.codpos),
      callback: function($$v) {
        _vm.codpos = $$v
      },
      expression: "codpos"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTreqest2.codjob) + " - " + _vm._s(_vm.detailTreqest2.desc_codjob))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTreqest2.codempmt) + " - " + _vm._s(_vm.detailTreqest2.desc_codempmt))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.qtydatrqyr
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP2']['60']) + "\n                  ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.qtydatrqmh
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP2']['70']) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.qtyreq
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP2']['120']) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.qtyact
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP2']['140']) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control text-center",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.qtyava
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['STD_REQP2']['160']) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTreqest2.amtincom))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTreqest2.desnoffi))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detailTreqest2.dtereqm)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTreqest2.desc_codrearq))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detailTreqest2.dteopen)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detailTreqest2.dteclose)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "value": "I",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.detailTreqest2.flgrecut === 'I' ? true : false
    }
  }), _vm._v("\n                      " + _vm._s(_vm.labels['STD_REQP2']['190']) + "\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "value": "E",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.detailTreqest2.flgrecut === 'E' ? true : false
    }
  }), _vm._v("\n                      " + _vm._s(_vm.labels['STD_REQP2']['200']) + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": "Y",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.detailTreqest2.flgjob === 'Y' ? true : false
    }
  }), _vm._v("\n                      " + _vm._s(_vm.labels['STD_REQP2']['240']) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": "Y",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.detailTreqest2.flgcond === 'Y' ? true : false
    }
  }), _vm._v("\n                      " + _vm._s(_vm.labels['STD_REQP2']['250']) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.desc_syncond
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['STD_REQP2']['260']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.detailTreqest2.desnote
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdreq-detail-accordion",
      "href": "#stdreq-detail-detail"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STD_REQP3']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdreq-detail-detail"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data['detail']
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba0c2d4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdreq/stdreqDetail.vue
// module id = 3962
// module chunks = 1